'use client';
import Script from 'next/script';
import { useEffect } from 'react';
import { clearAdrumCookies, setAdrumConfig } from './utils';
import {
  ADRUM_CLASS,
  ADRUM_OPTANON_CATEGORY,
  APP_DYNAMICS_ID
} from '../constants';

const APP_DYNAMICS_SCRIPT_SRC =
  '//cdn.appdynamics.com/adrum/adrum-24.4.0.4454.js';

/**
 * This component was built using the guide from AppD Adrum documentation for NextJS
 * https://community.appdynamics.com/t5/Knowledge-Base/Inject-the-JavaScript-Agent-with-React-Next-js-13-4-19/ta-p/53458
 */
export const AdrumConfig = () => {
  /**
   * Adds appdynamics config to the page when the OneTrustGroupsUpdated event is triggered
   */
  useEffect(() => {
    const isWindowDefined = typeof window !== 'undefined';
    const handleOneTrustGroupsUpdated = (e: CustomEvent) => {
      const detail = e.detail;
      console.log('OneTrustGroupsUpdated event triggered', detail);
      if (detail.includes(ADRUM_OPTANON_CATEGORY)) {
        setAdrumConfig();
      } else {
        clearAdrumCookies();
      }
    };
    if (isWindowDefined) {
      // window is accessible here.
      window.addEventListener(
        'OneTrustGroupsUpdated',
        handleOneTrustGroupsUpdated
      );
    }

    // Cleanup function to remove the event listener
    return () => {
      if (isWindowDefined) {
        window.removeEventListener(
          'OneTrustGroupsUpdated',
          handleOneTrustGroupsUpdated
        );
      }
    };
  }, []);

  return (
    <Script
      id={APP_DYNAMICS_ID}
      className={ADRUM_CLASS}
      src={APP_DYNAMICS_SCRIPT_SRC}
    ></Script>
  );
};
